
          import "Panel.styles_1ngdtt3.linaria.css";
          import { mediaQuery } from "@carvana/showroom-css-theme";
import { styled } from "@linaria/react";
const PanelContainer = /*#__PURE__*/styled("div")({
  name: "PanelContainer",
  class: "p1lv47lc"
});
export default PanelContainer;
          